import { AgentService, AgentError } from '@/services/agent.service'
import ApiService from '@/services/api.service'

const state =  {
    loading: false,
    types: [],
    subagents: [],
    serverResponse: null,
}

const getters = {
    loading: (state) => {
        return state.loading
    },

    types: (state) => {
        return state.types
    },

    subagents: (state) => {
        return state.subagents
    },

    serverResponse: (state) => {
        return state.serverResponse
    },
}

const actions = {
    async fetchTypes({ commit }) {
        commit('startRequest');
        try {
            const response = await AgentService.fetchTypes();
            commit('fetchTypesSuccess', response)
        } catch (e) {
            if (e instanceof AgentError) {
                commit('stopRequest', response)
            }

            return false
        }
    },

    async initiateSubAgentProcess({ commit }, {userName}) {
        commit('startRequest')
        try {
            const response = await AgentService.initiateSubAgentProcess(userName)
            commit('stopRequest', response)
            return response
        } catch (e) {
            if (e instanceof AgentError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return null
        }
    },

    async addSubagent({ commit }, { agentID, data }) { 
        commit('startRequest')
        try {
            const response = await AgentService.addSubagent(agentID, data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                let subagents = await AgentService.pullSubagents()
                commit('subagentSuccess', subagents)
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof AgentError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }
            return false
        }
    },

    async pullSubagents({ commit }, { agentID }) {
        commit('startRequest')
        try {
            let subagents = await AgentService.pullSubagents(agentID)
            
            commit('subagentSuccess', subagents)

            return true
        } catch (e) {
            if (e instanceof AgentError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async selfTransfer({ commit }, { data }) { 
        commit('startRequest')
        try {
            const response = await AgentService.selfTransfer(data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                commit('stopRequest', response)
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof AgentrError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }
            return false
        }
    },

    async saleUnits({ commit }, { data }) { 
        commit('startRequest')
        try {
            const response = await AgentService.saleUnits(data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                let subagents = await AgentService.pullSubagents()
                commit('subagentSuccess', subagents)
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof AgentError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }
            return false
        }
    },
}

const mutations = {
    startRequest(state) {
        state.loading = true
        state.serverResponse = null
    },

    fetchTypesSuccess(state, response) {
        state.types = response.types
        state.loading = false
    },

    stopRequest(state, response) {
        state.loading = false
        state.serverResponse = response
    },
    subagentSuccess(state, response){
       state.loading = false
       state.subagents = response.subagents
    },
}

export const agent = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
